import React, {
  useState,
  useEffect
} from 'react';

import {SiteLinks} from '../../general';

function HomePageInfo() {
  return (<SiteLinks screen="s2_student_homepage" />);
}

export {HomePageInfo};